import { useState } from 'react'
import styles from './SolutionsCTA.module.css'
import { sendContactEmail } from '../services/emailService'

const SolutionsCTA = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    projectType: '',
    message: ''
  })

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsSubmitting(true)

    try {
      const response = await sendContactEmail(formData)

      if (response.success) {
        setSubmitStatus('success')
        setFormData({
          name: '',
          email: '',
          company: '',
          projectType: '',
          message: ''
        })
      } else {
        setSubmitStatus('error')
      }
    } catch (error) {
      console.error('Solutions CTA form error:', error)
      setSubmitStatus('error')
    } finally {
      setIsSubmitting(false)
      setTimeout(() => setSubmitStatus('idle'), 5000)
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  return (
    <section id="solutions-contact" className={styles.section}>
      <div className={styles.background}>
        <div className={styles.blob1} />
        <div className={styles.blob2} />
        <div className={styles.blob3} />
      </div>

      <div className="container">
        <div className={styles.content}>
          <div className={styles.textSide}>
            <h2 className={styles.title}>
              Let's talk about{' '}
              <span className="gradient-text">your business.</span>
            </h2>
            <p className={styles.subtitle}>
              Tell us what is slowing you down. We'll get back to you with how
              we'd approach fixing it.
            </p>
            <div className={styles.note}>
              We review every request personally
            </div>
          </div>

          <div className={styles.formSide}>
            <form className={styles.form} onSubmit={handleSubmit}>
              <div className={styles.formGroup}>
                <label htmlFor="sc-name" className={styles.label}>Full Name <span className={styles.required} aria-hidden="true">*</span></label>
                <input
                  type="text"
                  id="sc-name"
                  name="name"
                  className={styles.input}
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Jane Doe"
                />
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="sc-email" className={styles.label}>Email <span className={styles.required} aria-hidden="true">*</span></label>
                <input
                  type="email"
                  id="sc-email"
                  name="email"
                  className={styles.input}
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="jane@company.com"
                />
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="sc-company" className={styles.label}>Company</label>
                <input
                  type="text"
                  id="sc-company"
                  name="company"
                  className={styles.input}
                  value={formData.company}
                  onChange={handleChange}
                  placeholder="Your Company Name"
                />
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="sc-projectType" className={styles.label}>What do you need help with? <span className={styles.required} aria-hidden="true">*</span></label>
                <select
                  id="sc-projectType"
                  name="projectType"
                  className={styles.select}
                  value={formData.projectType}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select one</option>
                  <option value="custom-software">Custom software build</option>
                  <option value="data-management">Data management</option>
                  <option value="process-improvement">Process improvement</option>
                  <option value="ai-integration">AI integration</option>
                  <option value="not-sure">Not sure yet, still figuring it out</option>
                </select>
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="sc-message" className={styles.label}>What's the problem you're trying to solve? <span className={styles.required} aria-hidden="true">*</span></label>
                <textarea
                  id="sc-message"
                  name="message"
                  className={styles.textarea}
                  rows={4}
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Tell us a bit about your business and what's not working."
                />
              </div>

              <button
                type="submit"
                className={styles.submitButton}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send message'}
              </button>

              {submitStatus === 'success' && (
                <div className={styles.successMessage}>
                  Got it. We'll read this carefully and be in touch.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className={styles.errorMessage}>
                  Something didn't go through. You can also reach us directly at contact@boxos.dev
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SolutionsCTA
